module.exports = __webpack_public_path__ + "img/join_resume03@2x.5db84cfc.png";